export * from './People1Icon';
export * from './People1Icon16Light';
export * from './People1Icon16Regular';
export * from './People1Icon16Solid';
export * from './People1Icon20Light';
export * from './People1Icon20Regular';
export * from './People1Icon20Solid';
export * from './People1Icon24Regular';
export * from './People1Icon24Solid';
export * from './People1Icon32Regular';
export * from './People1Icon64Regular';
